export const matchLeadToken = (location: string): string | undefined => {
  const fragments = location.match(
    /^\/seller-lead\/([-\w]+)|^\/home-value\/opendoor-homes\/[-\w]+\/([-\w]+)$/,
  );
  if (!fragments) {
    return undefined;
  }
  return fragments[1] || fragments[2];
};

export const matchSellerFlowSlug = location => {
  const fragments = location.match(/^\/seller-lead\/([-\w]+)\/([-\w]+)$/);
  if (!fragments) {
    return undefined;
  }
  return fragments[2];
};

export const matchSellerFlowPageName = location => {
  const fragments = location.match(/^\/seller-lead\/([-\w]+)\/p\/([-\w]+)$/);
  if (!fragments) {
    return undefined;
  }
  return fragments[2];
};

export const matchChannelQueryParam = queryParams => {
  const fragments = queryParams && queryParams.match(/channel\=([\w-]+)/);
  if (!fragments) {
    return undefined;
  }
  return fragments[1];
};

export const matchInAppQueryParam = queryParams => {
  const fragments = queryParams && queryParams.match(/app\=(\d+)/);
  if (!fragments) {
    return false;
  }
  return !!fragments[1];
};

export const matchKeywordsQueryParam = queryParams => {
  const fragments = queryParams.match(/keywords\=([\w-]+)/);
  if (!fragments) {
    return undefined;
  }
  return fragments[1];
};

export const matchHomeProfileSlug = location => {
  const fragments = location.match(/^\/home-value\/opendoor-homes\/([-\w]+)(\/[-\w]+)?$/);
  if (!fragments) {
    return undefined;
  }
  return fragments[1];
};

export const matchResaleOfferPortalPageName = location => {
  const fragments = location.match(/\/(makeoffer|makeoffers|make-offer|make-offers)\/([-\w]+)/);
  if (!fragments) {
    return undefined;
  }
  return fragments[2];
};
